// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f182fb7d","732":"fac53dcd"}[chunkId] + ".chunk.js";
};